exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sign-out{font-size:x-small;text-decoration:underline}.sign-out:hover{cursor:pointer}.test-button{border:solid #F58220 5px;background-color:#008E97;color:#F58220;color:white;margin-left:40%;font-weight:bold;font-family:cursive;letter-spacing:.08em;padding:8px;margin-right:40%;width:20%}\n", ""]);

